import { Routes } from '@angular/router';
import { AuthGuard } from '@zaoblako/web/core/guards/auth.guard';
import { GlobalDataLoadingGuard } from '@zaoblako/web/core/guards/global-data-loading.guard';
import { IsCheckLkGuard } from '@zaoblako/web/core/guards/is-check-lk.guard';
import { PermissionGuard } from '@zaoblako/web/core/guards/permission.guard';
import { UnsupportedVersionGuard } from '@zaoblako/web/core/guards/unsupported-version.guard';

export const dashboardRouter: Routes = [
  {
    path: '',
    canActivate: [UnsupportedVersionGuard, AuthGuard, IsCheckLkGuard, GlobalDataLoadingGuard, PermissionGuard],
    loadComponent: () => import('./components/dashboard/dashboard.component').then((c) => c.DashboardComponent),
    title: 'Рабочий стол'
  }
];
